/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByTopicKind = (typeof GroupByTopicKind)[keyof typeof GroupByTopicKind];

export const GroupByTopicKind = {
  topic: 'topic',
} as const;
